import React from "react";
import { useSelector } from "react-redux";
import useMovieTrailer from "../../hooks/useMovieTrailer";
import { RootState } from "../../store";

interface VideoBackgroundProps {
  movieId: number | string;
}

const VideoBackground: React.FC<VideoBackgroundProps> = ({ movieId }) => {
  const trailerVideo = useSelector((store: RootState) => store.movies?.trailerVideo);
  useMovieTrailer(movieId);

  return (
    <div className="w-full h-full relative overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-black/20 z-0"></div>
      <iframe
        className="w-full aspect-video scale-150 md:scale-125"
        src={`https://www.youtube-nocookie.com/embed/${trailerVideo?.key}?&autoplay=1&mute=1&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&loop=1&playlist=${trailerVideo?.key}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      ></iframe>
    </div>
  );
};

export default VideoBackground;
